<template>
  <div>
    <p class="mb-10 mt-10" style="font-size: 25pt; text-align: center">
      DETALLE VARIABLE
    </p>

    <v-card outlined>
      <v-toolbar flat>
        <v-btn @click="irAtras" icon>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title class="grey--text"
          >Detalle Variable
          <!-- <span v-if="variable">{{ variable.Name.es }}</span> -->
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn
          class="mx-1"
          depressed
          color="secondary"
          @click="irAddDataVariable"
          >Agregar Fuente de Datos</v-btn
        >
        <v-btn
          class="mx-1"
          depressed
          color="secondary"
          @click="showDialogAddDataCsv"
          >Agregar Fuente de datos desde .csv</v-btn
        >

        <v-btn
          class="mx-1"
          depressed
          color="red darken-1"
          dark
          @click="dialogDeleteDataVariable = true"
          >Eliminar Fuente de Datos</v-btn
        >
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text>
        <v-row>
          <v-col v-if="variable" cols="12">
            <h2 class="mb-3">{{ variable.Name.es }}</h2>
            <!-- <p class="mb-2">{{ variable.Id }}</p> -->
            <p class="mb-0">{{ variable.Description.es }}</p>
          </v-col>
          <v-col cols="12">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center">Id Ubicación</th>
                    <th class="text-center">Valor más Reciente</th>
                    <th class="text-center">Historico</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in dataVariable" :key="item.Id">
                    <td class="text-center">{{ item.IdUbication }}</td>
                    <td class="text-center">
                      {{ item.Value }} ({{ variable.Unidad.Id }})
                    </td>
                    <td class="text-center">{{ item.Historico }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogDeleteDataVariable" persistent max-width="350">
      <v-card>
        <v-card-title class="headline">
          ¿Eliminar información cargada para esta variable?
        </v-card-title>
        <v-card-text
          >Al eliminar esta información, no podrá ser recuperada. También puedes
          eliminar la información para cargar una más actualizada.</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogDeleteDataVariable = false">
            <b>Cancelar</b>
          </v-btn>
          <v-btn color="red darken-1" text @click="deleteDataVariable()">
            <b>Eliminar</b>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addDataCsvDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">
          Subir el archivo .csv
        </v-card-title>
        <v-card-text>
          Recuerda el formato debe ser el id de la ubicacion en la primera filas, en la segunda el año y en la tercera el valor.
        </v-card-text>
        <div style="padding: 1rem">
        <v-form ref="formDataLoad">
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="dataLoad.Fuente"
                label="Fuente Informacion"
                outlined
                hide-details="auto"
                required
                :rules="rules"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="dataLoad.Ano"
                label="Año Publicación"
                outlined
                hide-details="auto"
                required
                type="number"
                :rules="rules"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <v-file-input accept=".csv" v-model="file"></v-file-input>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="addDataCsvDialog = false">
            <b>Cancelar</b>
          </v-btn>
          <v-btn color="green darken-1" text @click="addDataCsv()">
            <b>Agregar data</b>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar.show"
      top
      color="primary"
      right
      transition="slide-x-reverse-transition"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>

<script>
import api from "@/api/api";

export default {
  name: "Indices",
  data() {
    return {
      idVariable: null,
      variable: null,
      dataLoad: {
        Fuente: null,
        Ano: null,
      },
      file: null,
      rules: [(v) => !!v || "Este campo es requerido"],
      dataVariable: [],
      addDataCsvDialog: false,
      dialogDeleteDataVariable: false,
      snackbar: {
        show: false,
        text: null,
        color: null,
      },
    };
  },
  mounted() {
    const idVariable = this.$route.params.idVariable;
    this.idVariable = idVariable;
    this.getVariable(idVariable);
    this.getDataVariable(idVariable);
  },
  methods: {
    async getVariable(idVariable) {
      try {
        const data = await api.getVariable(idVariable);

        if (data.status) {
          // console.log(data.data);
          this.variable = data.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getDataVariable(idVariable) {
      try {
        const data = await api.getDataVariable(idVariable);
        if (data.status) {
          this.dataVariable = data.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    irAddDataVariable() {
      this.$router.push(`/admin/variables/${this.idVariable}/upload-data`);
    },
    async deleteDataVariable() {
      try {
        const data = await api.deleteDataVariable(this.idVariable);
        console.log(data);
        this.dialogDeleteDataVariable = false;
        this.showSnackbar("Se eliminó correctamente la información", "primary");
        this.dataVariable = [];
      } catch (err) {
        console.log(err);
      }
    },
    showSnackbar(message, color) {
      this.snackbar.text = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    addDataCsv(){
      const reader = new FileReader();
      reader.onload =  async() => {
        if (typeof reader.result == 'string') {
          const dataVariable = []
          const idsUbications = new Set()
          const lines = reader.result.split('\n').map((line) =>{
            return line.split(',')
          })

          lines.map((line) => {
            line[2] = parseInt(line[2])
            idsUbications.add(line[0])
          })

          for(let id of idsUbications) {
            let dataModel = {
              IdUbication: id,
              Historico: []
            }
            for (let line of lines) {
              if (line[0] === id) {
                dataModel.Historico.push([line[1], line[2]])
              }
            }
            dataVariable.push(dataModel)
          }
          try {
            if (dataVariable.length > 0) {
              if (this.$refs.formDataLoad.validate()) {
                this.loading = true;
                const data = await api.addDataVariable(
                  this.idVariable,
                  dataVariable,
                  this.dataLoad
                );
                this.loading = false;
                if (data.status) {
                  this.showSnackbar(
                    "Los datos se cargaron correctamente",
                    "primary"
                  );
                  this.addDataCsvDialog = false;
                  this.getDataVariable(this.$route.params.idVariable);
                }
              } else {
                this.showSnackbar("¡Completa los campos requeridos!", "error");
              }
            } else {
              this.showSnackbar(
                "Tienes que cargar un archivo JSON valido",
                "error"
              );
            }
          } catch (err) {
            console.log(err);
          }
        }
      };
      reader.readAsText(this.file)
    },
    showDialogAddDataCsv() {
      this.addDataCsvDialog = true;
    },
    irAtras() {
      this.$router.go(-1);
    },
  },
};
</script>
